import { Card as CardPrimitive } from '@/components/ui/card';

const Card = ({ children }: React.PropsWithChildren) => {
  return <CardPrimitive>{children}</CardPrimitive>;
};

export { Card };
